
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">Uses Matrixcare</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div><div class="font-weight-bold">Activating this Physician/NPPA user will also grant them login access to MatrixCare 360.</div>
      <br>
      <div >Are you sure you want to proceed?</div>
    </div>
    <div class="modal-footer mt-4">
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="accept()">Continue</button>
      <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
